import { render, staticRenderFns } from "./updateuserdetail.vue?vue&type=template&id=12f69bb2&scoped=true&"
import script from "./updateuserdetail.vue?vue&type=script&lang=js&"
export * from "./updateuserdetail.vue?vue&type=script&lang=js&"
import style0 from "./updateuserdetail.vue?vue&type=style&index=0&id=12f69bb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f69bb2",
  null
  
)

export default component.exports